const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY)

export const apiClientLotalty = {
	summaryBites: async (clientId: number): Promise<IClientLoyaltyBiteStatsModel> => {
		const { data } = await apiCommon<IClientLoyaltyBiteStats>(`${groupPrefix}/${clientId}/stats`, { method: 'GET' })

		return clientLoyaltyBiteStatsFromJSON(data)
	},
	historyBites: async (
		clientId: number,
		page: number = 1,
		perPage: number = 25,
	): Promise<{ data: IClientLoyaltyBitesTransactionModel[]; meta: IApiMetaModel | undefined }> => {
		const { data, meta } = await apiCommon<IClientLoyaltyBitesTransaction[]>(`${groupPrefix}/${clientId}/history`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(clientLoyaltyBitesTransactionFromJSON), meta }
	},
}
